
class ReportsPermissionsDataSource extends MIOObject
{
    private tableView:UITableView = null;
    initWithTableView(tableView:UITableView){
        this.tableView = tableView;
    }

    private _user:User = null;
    get user(){return this._user;}
    set user(value:User) {
        this._user = value;
        this.tableView.reloadData();
    }

    numberOfSections(tableView:UITableView){
        return this.fetchedResultsController.sections.length;
    }

    numberOfRowsInSection(tableView:UITableView, section:number){
        let sec = this.fetchedResultsController.sections[section];
        return sec.numberOfObjects();
    }

    titleForHeaderInSection(tableView:UITableView, section:number) {
        let ip = MIOIndexPath.indexForRowInSection(0, section);
        let item = this.fetchedResultsController.objectAtIndexPath(ip); 
        return item.section;        
    }

    cellAtIndexPath(tableView:UITableView, indexPath: MIOIndexPath) {
        let cell = tableView.dequeueReusableCellWithIdentifier("ReportPermissionCell") as ReportsPermissionCell;
        
        let item = this.fetchedResultsController.objectAtIndexPath(indexPath) as ReportLocalized;
        cell.title = item.name;
        
        cell.accessoryType = this._user.hasReportID(item.report.identifier) ? UITableViewCellAccessoryType.Checkmark : UITableViewCellAccessoryType.None;
        return cell;
    }

    // canSelectCellAtIndexPath(tableView:MUITableView, indexPath:MIOIndexPath){
    //     let item = this.fetchedResultsController.objectAtIndexPath(indexPath);

    //     let loginEmail = MIOUserDefaults.standardUserDefaults().valueForKey("LastLoginEmail");                        
    //     if (this._user.email == loginEmail && item.bitMask == 47) return false;

    //     return true;
    // }    

    didSelectCellAtIndexPath(tableView:UITableView, indexPath:MIOIndexPath){
        let cell = tableView.cellAtIndexPath(indexPath) as ReportsPermissionCell;

        let item = this.fetchedResultsController.objectAtIndexPath(indexPath) as ReportLocalized;
        
        //if user currently has permission, remove them
        if (this._user.hasReportID(item.report.identifier)) {
            // Remove
            this._user.removeReportID(item.report.identifier);
            cell.accessoryType = UITableViewCellAccessoryType.None;
        }
        else {
            //add permission to the user.buinessPermission
            this._user.addReportID(item.report.identifier);
            cell.accessoryType = UITableViewCellAccessoryType.Checkmark;
        }        
    }

    private _fetchedResultsController = null;
    set fetchedResultsController(value){
        if (value == null && this._fetchedResultsController != null)
            this._fetchedResultsController.delegate = null;
    
        this._fetchedResultsController = value;
    }    

    get fetchedResultsController(){
        if (this._fetchedResultsController != null)
            return this._fetchedResultsController;
    
        let ad:AppDelegate = MUIWebApplication.sharedInstance().delegate;

        let fetchRequest = MIOFetchRequest.fetchRequestWithEntityName('ReportLocalized');
        fetchRequest.relationshipKeyPathsForPrefetching = ["report"];
        fetchRequest.sortDescriptors = [ MIOSortDescriptor.sortDescriptorWithKey('report.orderIndex', true),
                                        MIOSortDescriptor.sortDescriptorWithKey('name', true)];
        
        let lang = SettingsHelper.sharedInstance().currentSupportedLanguage;
        let predicateFormat = "language = '" + lang + "'";
        
        fetchRequest.predicate = MIOPredicate.predicateWithFormat(predicateFormat);

        let fetchedResultsController = new MIOFetchedResultsController();
        fetchedResultsController.initWithFetchRequest(fetchRequest, ad.managedObjectContext, 'section');
        fetchedResultsController.delegate = this;        

        fetchedResultsController.performFetch(); 
        
        this._fetchedResultsController = fetchedResultsController;   
        return this._fetchedResultsController;
    }
    
    controllerDidChangeContent(controller:MIOFetchedResultsController){        
        this.tableView.reloadData();
    }
}